import { useSettingsStore } from '../../stores/settingsStore';

export function LanguageSwitcher() {
  const { language, setLanguage } = useSettingsStore();

  return (
    <div className="language-switcher" role="group" aria-label="Language selection">
      <button
        className={`lang-button ${language === 'en' ? 'lang-button-active' : ''}`}
        onClick={() => setLanguage('en')}
        aria-pressed={language === 'en'}
      >
        EN
      </button>
      <button
        className={`lang-button ${language === 'ru' ? 'lang-button-active' : ''}`}
        onClick={() => setLanguage('ru')}
        aria-pressed={language === 'ru'}
      >
        RU
      </button>
    </div>
  );
}
